module.exports = __webpack_public_path__ + "static/media/favicon.1d570ef9.ico";